module.exports = __webpack_public_path__ + "static/media/strategicPartnerships.132f0cb4.svg";